// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUsers } from '@tabler/icons';

const icons = {
    IconUsers
};

// ==============================|| MENU ITEMS - EMPLOYEES ||============================== //

const employees = {
    id: 'employees',
    title: <FormattedMessage id="employees" />,
    icon: icons.IconUsers,
    type: 'group',
    url: 'employees',
    roles: ['employee', 'employer']
};

export default employees;
